import { render, staticRenderFns } from "./KT-ImgUpld.vue?vue&type=template&id=2d8b9a3a&scoped=true&lang=pug&"
import script from "./KT-ImgUpld.vue?vue&type=script&lang=js&"
export * from "./KT-ImgUpld.vue?vue&type=script&lang=js&"
import style0 from "./KT-ImgUpld.vue?vue&type=style&index=0&id=2d8b9a3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b9a3a",
  null
  
)

export default component.exports